'use client';

import React__default, { memo, useState, useCallback, useEffect } from 'react';
import { Gird } from './styled.js';
import Typography from '../Typography/index.js';
import Button from '../Button/index.js';
import { colors } from '../Colors/index.js';

function CustomRadio(_a) {
    var _b;
    var options = _a.options, defaultValue = _a.defaultValue, onChangeProp = _a.onChange;
    if (!options || options.length < 0) {
        throw new Error('Some thing wrong, No data found');
    }
    var _c = useState(defaultValue), state = _c[0], setState = _c[1];
    var onClickCb = useCallback(function (value) {
        if (state === value)
            return;
        onChangeProp && onChangeProp(value);
        setState(value);
    }, [state, onChangeProp]);
    useEffect(function () {
        if (defaultValue) {
            setState(defaultValue);
        }
    }, [defaultValue]);
    return (React__default.createElement(Gird, { col: (_b = options.length) !== null && _b !== void 0 ? _b : 0 }, options === null || options === void 0 ? void 0 : options.map(function (option, index) {
        return (React__default.createElement(Button, { key: "".concat(option.value, "_").concat(index), outline: 'outline', onClick: function () {
                onClickCb(option.value);
            }, type: option.value === state ? 'info' : 'default' },
            React__default.createElement(Typography, { name: 'body', size: 'medium', color: option.value === state ? colors.primary[40] : colors.grey[20] }, option.name)));
    })));
}
var CustomRadio$1 = memo(CustomRadio);

export { CustomRadio$1 as default };
//# sourceMappingURL=index.js.map
